<table class="pivot-table">
    <tbody>
        @for (row of updatedCellset(); track row; let l = $last) {
            <tr>
                @for (column of row; track column) {
                    @if (column.type === "COLUMN_HEADER" || column.type === "ROW_HEADER_HEADER" || column.type === "ROW_HEADER") {
                        <th
                            [attr.colspan]="column.properties.colspan"
                            [ngClass]="{
                                'py-1': true,
                                'px-2': true,
                                column__header: column.type === 'COLUMN_HEADER',
                                'row__header-header': column.type === 'ROW_HEADER_HEADER',
                                row__header: column.type === 'ROW_HEADER',
                                'table-header': column.type === 'COLUMN_HEADER' || column.type === 'ROW_HEADER_HEADER' || column.type === 'ROW_HEADER',
                                column__empty: !l && !column.value && column.type === 'ROW_HEADER',
                                'no-border-top': l && !column.value && column.type === 'ROW_HEADER',
                                pointer: column.properties.color,
                                selected: selected() === (column.value | removeSpaces | lowercase),
                            }"
                            class="{{ convertToClassListString(column.properties.classnames) }}"
                            (click)="doOnHeaderClick(column)"
                        >
                            @if (column.properties.color) {
                                <div class="pivot-table__color" [style.background]="column.properties.color"></div>
                            }
                            {{ column.value }}
                        </th>
                    } @else {
                        <td
                            class="column__cell p-2 text-right {{ convertToClassListString(column.properties.classnames) }}"
                            [class.table-header]="column.properties.color"
                            [ngStyle]="{
                                width: column.properties?.format?.width + 'px' || 'auto',
                            }"
                        >
                            {{ column.value }}
                        </td>
                    }
                }
            </tr>
        }
    </tbody>
</table>
